import React from 'react';
import HeaderItem from '../HeaderItem';
import { useAppStore } from '../../../context/AppContext';
import { SidePanelModulEnum } from '../../../enums/sidePanelModulEnum';

const UserInfoComponent: React.FC = () => {
    const { setVisibleSidePanelModuleIndex } = useAppStore();

    const itemClicked = () => () => {
        setVisibleSidePanelModuleIndex(SidePanelModulEnum.About);
    };

    return <HeaderItem title="About" iconName={'user-circle'} path={''} onItemClick={itemClicked()} />;
};

export default UserInfoComponent;
